module.exports = __webpack_public_path__ + "static/img/016石油设计院.b177526.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/016石油设计院.jpg
// module id = eLc4
// module chunks = 0